module.exports = __webpack_public_path__ + "img/icon-edit.b80a17f7.svg";